"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var Announced_base_1 = require("./Announced.base");
var Announced_styles_1 = require("./Announced.styles");
exports.Announced = Utilities_1.styled(Announced_base_1.AnnouncedBase, Announced_styles_1.getStyles);
//# sourceMappingURL=Announced.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/Announced/Announced.js
// module id = 669
// module chunks = 0